export default "__VITE_ASSET__BudqUQmd__"